export const Style = ({ colors = [] }) => (
  <g id="Estilo3_1_">
    <linearGradient
      id="Multiply_60_"
      gradientUnits="userSpaceOnUse"
      x1="75.635"
      y1="384.7063"
      x2="75.635"
      y2="408.0965"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
      <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
      <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
      <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
      <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
    </linearGradient>
    <path
      id="Multiply_9_"
      style={{
        opacity: '0.6',
        fill: 'url(#Multiply_60_)',
        enableBackground: 'new'
      }}
      d="M71.8,79.4c0,0,1.3,1.3,4,1.4 c1.2,0.1,2.4-0.2,3.6-0.8c0,0,0,2.9-4.5,2.6C72.6,82.4,71.8,79.4,71.8,79.4z"
    />
    <path
      style={{ fill: colors[0] }}
      d="M71.3,77.9c-0.3-0.2-0.5-0.3-0.7-0.5c-0.3-0.2-0.3-0.5-0.1-0.8c0.2-0.2,0.6-0.3,0.8-0.1 c0.2,0.2,4.8,3.7,8,0.5c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8C77.3,80.5,73.5,79.2,71.3,77.9z"
    />
  </g>
)
